import React, { FC } from 'react';
import ReactTooltip from 'ati-ui-react/components/ReactTooltip';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';

interface Props {
  id: string | number;
  className?: string;
  effect?: string;
  place?: string;
}

const DesktopTooltip: FC<Props> = observer(({ className, children, id, effect, place }) => {
  const {
    appStore: { isDesktop },
  } = useStores();

  if (!isDesktop) return null;

  return (
    <ReactTooltip id={id} effect={effect} place={place} className={cn(className)}>
      {children}
    </ReactTooltip>
  );
});

export default DesktopTooltip;
